'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Small } from 'foundations-components/transitional/components/Small';
import { EXPORT_TYPES_FOR_REPORT } from '../../shared/emailLogic';
import { getEventValue } from '../../../utils/jsEventUtils';
import { useControlsContext } from '../context';
import { DATA_EXPORT_URL } from '../../../lib/linkUrls';
import { isUnsupportedDataExportType } from '../../shared/emailLogic';
import { UNSUPPORTED_REPORT_TYPE } from '../../problems';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EXPORT_TYPES_FOR_REPORT_OPTIONS = EXPORT_TYPES_FOR_REPORT.map(dataType => {
  return {
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-action-components.actions.emailReport.dialog.exportType.${dataType.toLowerCase()}`
    }),
    value: dataType
  };
});
const DataExportSelect = () => {
  const {
    dataExportType,
    setDataExportType,
    dataExportProblem
  } = useControlsContext();
  const {
    problem,
    disabledMessage
  } = dataExportProblem;
  const shouldDisplayDataExport = !problem;
  const DisableMessage = problem === UNSUPPORTED_REPORT_TYPE ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "reporting-action-components.actions.exportReport.button.tooltip.emailExportTypeNotSupported_jsx",
    elements: {
      UILink: Link
    },
    options: {
      href: DATA_EXPORT_URL
    }
  }) : disabledMessage;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailDataExport"
      }),
      tooltip: !shouldDisplayDataExport && DisableMessage,
      required: true,
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "email-report-data-export-select",
        disabled: !shouldDisplayDataExport,
        onChange: e => setDataExportType(getEventValue(e)),
        options: EXPORT_TYPES_FOR_REPORT_OPTIONS,
        value: dataExportType
      })
    }), isUnsupportedDataExportType(dataExportType) && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.exportReport.emailDataExportDescription"
      })
    })]
  });
};
export default DataExportSelect;